var LayoutMappa = (function () {


  /* ---------------------------------------------------------
  FLAG INIT - data-init viene impostato a completamento di mapInit()
  --------------------------------------------------------- */

  var isInit = function () {
    if( $('#projects-map').attr('data-init') === 'true' ){
      return true; // mappa già inizializzata da mapInit()
    } else {
      return false; // mappa ancora da inizializzare
    }
  };

  // var inizializzata = $('#projects-map').attr('data-init');



  /* ---------------------------------------------------------
  Module: VARIABILI GLOBALI MAPPA
  Added:
  --------------------------------------------------------- */
  if( (jQuery('body').hasClass('home') || jQuery('body').hasClass('page-template-template-archivio-edizioni') || jQuery('body').hasClass('page-template-template-gallery')) && typeof google !== 'undefined' ){

    var map;
    var has_adminbar = jQuery('#wpadminbar');
    var h_padding = 28;

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - MAP
    var mapcenter = new google.maps.LatLng(42, 12);
    var mapbounds;
    var minZoom = 2;
    var baseZoom = 5;
    var mapOptions;
    var openInfoWindow = null;
    var markerArray = [];

    // ── HTML escape utility ──
    function escHtmlMap(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // ── Render tile-gallery popup for InfoWindow ──
    function renderMapPopup(opts) {
      // opts: { title, url, author, thumbUrl, locationTag, typeTag, linkAttrs }
      var imgHtml = opts.thumbUrl
        ? '<img class="bg" src="' + opts.thumbUrl + '" alt="" loading="lazy">'
        : '';

      var authorHtml = opts.author
        ? '<p class="author">' + escHtmlMap(opts.author) + '</p>'
        : '';

      var linkAttrs = opts.linkAttrs || '';

      var locationTagHtml = opts.locationTag
        ? '<span comp="tags" class="--light"><span>' + escHtmlMap(opts.locationTag) + '</span></span>'
        : '';

      var typeTagHtml = opts.typeTag
        ? '<span comp="tags" class="--light"><span>' + escHtmlMap(opts.typeTag) + '</span></span>'
        : '';

      var tagsHtml = (locationTagHtml || typeTagHtml)
        ? '<div class="tags">' + locationTagHtml + typeTagHtml + '</div>'
        : '';

      return '<div comp="tile-gallery" class="--grid --small --iw">' +
        imgHtml +
        '<div class="tile">' +
          '<div class="content">' +
            '<div class="card">' +
              '<div class="card-text">' +
                '<div class="card-header">' +
                  authorHtml +
                  '<button type="button" class="iw-close">' +
                    '<span class="material-symbols-outlined">close_small</span>' +
                  '</button>' +
                '</div>' +
                '<p class="title">' + escHtmlMap(opts.title) + '</p>' +
              '</div>' +
              '<a href="' + opts.url + '"' + linkAttrs + ' class="scopri-link">' +
                '<span comp="button" class="--secondary"><span class="label">Scopri</span><span class="underline"></span></span>' +
              '</a>' +
            '</div>' +
          '</div>' +
          tagsHtml +
        '</div>' +
      '</div>';
    }

  }

  /* ---------------------------------------------------------
  Module: Inizializzazione mappa
  Added:
  --------------------------------------------------------- */

  var mapInit = function () {
    //console.log('map initialized');
    mapOptions = {
      zoom: baseZoom,
      minZoom: minZoom,
      maxZoom: 16,
      zoomControl: true,
      scrollwheel: false,
      streetViewControl: false,

      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      },
      center: mapcenter,
      // mapTypeId: google.maps.MapTypeId.TERRAIN,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
      },
        // styles: styles
      styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
    };
    map = new google.maps.Map(document.getElementById("projects-map"), mapOptions);
    google.maps.event.trigger(map, 'resize');
  };




  /* ---------------------------------------------------------
  Module: Caricamento dati mappa ex ubp_loadMapData
  Added:
  --------------------------------------------------------- */

  var mappa = function (projects_data, from) {

    // console.log('from: ' + from);
    //console.log(projects_data);

    var dropCounter = 0;
    var mapmarker_path = $('#projects-map').attr('data-markerpath');
    mapbounds = new google.maps.LatLngBounds();
    var lastIdx = projects_data.posts.length - 1;

    // reset markers
    if (markerArray.length > 0) {
    	$.each(markerArray, function(idx, value) {
    		value.setMap(null);
    	});
    }

    markerArray = [];

    // -----------------------------------------
    // se sono stati passati i dati dei post
    if (projects_data !== undefined) {

    	$.each(projects_data.posts, function(idx, value) {
        // escludo gli eventi
        if(value.tipo_di_post !== 'eventi'){
    			if (value.locations.length > 0) {
    				for (var a=0;a<value.locations.length;a++) {

    					value.lat = value.locations[a].lat;
    					value.lng = value.locations[a].lng;
    					var marker_zpos = parseInt(8000 + idx);
    					var image = {
    						url: mapmarker_path + '/mapmarker.png',
    						scaledSize: new google.maps.Size(16, 24),
    						origin: new google.maps.Point(0, 0),
    						anchor: new google.maps.Point(8, 21),
    						zIndex: marker_zpos
    					};

              // PROGETTO O CONTRIBUTO - post_type
              var post_type = value.tipo_di_post;
              var post_id = value.id;


              // COLORE GLOBALE
              coloreMarkerProgetti = getComputedStyle(document.querySelector('body')).getPropertyValue('--gamma');
              coloreMarkerContributi = getComputedStyle(document.querySelector('body')).getPropertyValue('--beta');

              // ---------------------------------------
              // CAMPI PROGETTO
              if(post_type == 'progetti'){

                // MARKER PROGETTO
                // setto posizione e icona del marker
                var marker = new google.maps.Marker({
                  position: new google.maps.LatLng(value.lat, value.lng),
                  map: map,
                  //animation: google.maps.Animation.DROP,
                  title: value.title,
                  icon: ' ',
                  label: {
                    fontFamily: "'Font Awesome 5 Pro'",
                    text: '\uf3c5', //icon code
                    fontWeight: '300', //careful! some icons in FA5 only exist for specific font weights
                    color: coloreMarkerProgetti, //color of the text inside marker
                    fontSize: '2rem',
                  }
                });

                // campo city per tag
                var cities = [];
                for (var c=0;c<value.locations.length;c++) {
                  if ( value.locations[c].hasOwnProperty('city') ) {
                    if (value.locations[c].city !== '') {
                      cities.push(value.locations[c].city);
                    }
                  }
                }

                // contenuto del popup PROGETTO
                var popupContent = renderMapPopup({
                  title: value.title,
                  url: value.permalink,
                  author: value.nome_promotore || '',
                  thumbUrl: value.tile_thumb_url || '',
                  locationTag: cities.length > 0 ? cities.join(', ') : '',
                  typeTag: 'Progetto'
                });
              }


              // ---------------------------------------
              // CAMPI CONTRIBUTI
              if(post_type == 'contributi'){

                // MARKER CONTRIBUTO
                // setto posizione e icona del marker
                var marker = new google.maps.Marker({
                  position: new google.maps.LatLng(value.lat, value.lng),
                  map: map,
                  //animation: google.maps.Animation.DROP,
                  title: value.title,
                  icon: ' ',
                  label: {
                    fontFamily: "'Font Awesome 5 Pro'",
                    text: '\uf3c5', //icon code
                    fontWeight: '300', //careful! some icons in FA5 only exist for specific font weights
                    color: coloreMarkerContributi, //color of the text inside marker
                    fontSize: '2rem',
                  }
                });

                var tipo_contributo = value.tipo_contributo;
                var contributo_video = value.contributo_video;

                var contributore = '';
                if (value.contributo_cognome !== '') {
                  contributore = (value.contributo_nome + ' ' + value.contributo_cognome).trim();
                }

                // contenuto del popup CONTRIBUTI
                var popupUrl, popupLinkAttrs;
                if (tipo_contributo == 'testo') {
                  popupUrl = 'javascript:;';
                  popupLinkAttrs = ' data-fancybox="" data-src="#contributo-' + value.id + '"';
                } else {
                  popupUrl = contributo_video || value.permalink;
                  popupLinkAttrs = contributo_video ? ' data-fancybox=""' : '';
                }

                var popupContent = renderMapPopup({
                  title: value.title,
                  url: popupUrl,
                  author: contributore,
                  thumbUrl: value.tile_thumb_url || '',
                  locationTag: '',
                  typeTag: 'Contributo',
                  linkAttrs: popupLinkAttrs
                });
              }


              // ---------------------------------------
              // COSTRUZIONE MAPPA

    					var infowindow = new google.maps.InfoWindow({
          			content: popupContent
          		});

              google.maps.event.addListener(marker, 'click', function() {
    						if (openInfoWindow) openInfoWindow.close();
    						infowindow.open(map, marker);
    						openInfoWindow = infowindow;
    					});

              google.maps.event.addListener(map, "click", function(event) {
                infowindow.close();
              });

              google.maps.event.addListener(infowindow,'domready',function(){
                $('[comp="tile-gallery"].--iw').closest('.gm-style-iw').parent().addClass('custom-iw');

                // Close button binding
                var closeBtn = document.querySelector('.iw-close');
                if (closeBtn) {
                  closeBtn.addEventListener('click', function(e) {
                    e.stopPropagation();
                    infowindow.close();
                    openInfoWindow = null;
                  });
                }
              });

    					markerArray.push(marker);
    					if (lastIdx == idx) {
    						$(".navbar.filters").fadeIn("slow");
    					}

    					mapbounds.extend(new google.maps.LatLng(value.lat, value.lng));

    				}
    			}

        } // if(value.tipo_di_post !== 'eventi'){

    	});

    	map.fitBounds(mapbounds);
    }

    // -----------------------------------------
    // altrimenti carico una mappa vuota
    else {

    	// reset markers
    	if (markerArray.length > 0) {
    		$.each(markerArray, function(idx, value) {
    			value.setMap(null);
    		});
    	}

    	markerArray = [];
    	map.setZoom(baseZoom);
    	map.setCenter(mapcenter);
    	mapbounds = new google.maps.LatLngBounds();
    	mapbounds.extend(new google.maps.LatLng(37.490000, 8.625556));
    	mapbounds.extend(new google.maps.LatLng(47.091944, 18.521667));
    	map.fitBounds(mapbounds);
    	google.maps.event.trigger(map, 'resize');
    }

    /* ^ FINE mapLoadData ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  Module: MAP RESIZE
  Added:
  --------------------------------------------------------- */

  var mapResize = function () {

    if($('#maptoggle').hasClass('active')){

      $('#projects-map').removeClass('d-none');

      var has_adminbar = $('#wpadminbar');
      var h_padding = 28;

      var filters_h = 0; //$('.tile-filters .urbox').outerHeight();
      var filters_w = $('#menu-filters').width();
      var window_h = $(window).height();
      var available_h = parseInt(window_h - (2 * filters_h) - h_padding - 14);
      if (has_adminbar[0]) {
        available_h = available_h - 32;
      }
      $('#projects-map').width(filters_w - 2 -14);
      $('#projects-map').height(available_h);

    } else {
      $('#projects-map').addClass('d-none');
    }



    /* ^ FINE CONTRIBUTO ----------------------------------------- */
  };


  return {
    isInit : isInit,
    mapInit : mapInit,
    mappa : mappa,
    // mapLoadData : mapLoadData,
    mapResize : mapResize
  }


})();
